import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

export const DialogViewNameError = (props) => {
    const onCloseConfirm = async(event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        await props.setIsOpenDialogViewNameError(false);
        await props.inputViewNameRef.current.focus();
    };

    return (
        <Dialog
            open={props.isOpenDialogViewNameError}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {props.viewNameErrorType === Constant.EDIT_VIEW_NAME_ERROR_TYPE.BLANK &&
                        'ビュー名は空欄にすることが出来ません。'}
                    {props.viewNameErrorType === Constant.EDIT_VIEW_NAME_ERROR_TYPE.DUPLICATE &&
                        '入力したビュー名は既に登録されています。他の名称を入力してください。'}

                    <IconButton
                        className="close"
                        onClick={(event, reason) => onCloseConfirm(event, reason)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    はい
                </Button>
            </DialogActions>
        </Dialog>
    );
};
